<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
      <!-- <div class="col-sm-12">
        <span><a class="cursor-link" (click)="goToTheme()">Preview</a> > Education > Experience > <strong>Skills</strong></span>
      </div> -->
    </div>
  </div>
</div>
<div class="addSkills">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h2>Add Skills</h2>
      </div>
      <div class="col-sm-8">
        <div class="row addSkills_list" *ngFor="let skill of skills.skills">
          <div class="col-sm-6">
            <div class="form-group">
              <input type="text" class="form-control" name="skills_2" placeholder="Skills" [(ngModel)]="skill.skill" required>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="addSkills__stars">
              <span *ngFor="let i of [1,2,3,4,5]" class="icon {{skill.rating >=i ? 'icon-star': 'icon-star-empty'}}" (click)="skill.rating=i"></span>
            </div>
          </div>
          <div class="col-sm-3">
            <button class="btn btn-sm btn-primary" (click)="remove(skill)">Delete</button>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="titleBody">
          <div class="titleAdd">
            <div class="titleAdd__plus" *ngFor="let skill of skillsList" (click)="addMore(skill)">
              <div class="titleAdd__text"><span>Add</span></div>
              <div class="titleAdd__body">{{skill.skill}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-12">
        <div class="addSkills__buttons">
          <button class="btn btn-default" routerLink="/resume/exp">Back</button>
          <button class="btn btn-default" routerLink="/themes/{{theme_id}}">Skip</button>
          <button class="btn btn-primary" (click)="save()">Save &amp; Next</button>
        </div>
      </div>
      <!-- <div class="col-sm-6 col-8 text-right">
        <div class="addSkills__buttons">
          <button class="btn btn-default" routerLink="/themes/{{theme_id}}">Skip</button>
          <button class="btn btn-primary" (click)="save()">Save &amp; Next</button>
        </div>
      </div> -->
    </div>
  </div>
</div>
<app-footer></app-footer>
